import React from 'react'

export const Checkbox = ({
  input,
  label,
  id,
  className,
  meta: { touched, error },
  ...other
}) => (
  <div className={className}>
    <div className="checkbox">
      <input id={id} name={input.name} type="checkbox" {...input} {...other} />
      <label htmlFor={id}>{label}</label>
      {touched && error && <div className="slide error">{error}</div>}
    </div>
  </div>
)

export default Checkbox
